<template>
  <div class="m-menu">
    <dl class="nav" @mouseleave="menuLeave">
      <dt>全部分类</dt>
      <dd
        v-for="(item, index) in menuList"
        :key="index"
        @mouseenter="menuEnter(item)"
      >
        <i :class="item.type"></i>{{ item.name }}
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-school"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://minsu.meituan.com/?phx_wake_up_type=mtpc_category&amp;phx_wake_up_source=nav"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":10000020,"index":"4_1","title":"民宿"}}'
              class="link nav-text"
              target="_blank"
              >民宿</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-view"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://maoyan.com/films?utm_source=meituanweb"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":99,"index":"5_1","title":"猫眼电影"}}'
              class="link nav-text"
              target="_blank"
              >猫眼电影<span class="nav-promotion">HOT</span></a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-position"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://www.meituan.com/flight/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":10000009,"index":"6_1","title":"机票"}}'
              class="link nav-text"
              target="_blank"
              >机票</a
            >
            / </span
          ><span
            ><a
              href="https://www.meituan.com/train/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":10000001,"index":"6_2","title":"火车票"}}'
              class="link nav-text"
              target="_blank"
              >火车票</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-microphone"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/xiuxianyule/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":2,"index":"7_1","title":"休闲娱乐"}}'
              class="link nav-text"
              target="_blank"
              >休闲娱乐</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/xiuxianyule/c10/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":10,"index":"7_2","title":"KTV"}}'
              class="link nav-text"
              target="_blank"
              >KTV</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-s-platform"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/shenghuo/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":10000040,"index":"8_1","title":"生活服务"}}'
              class="link nav-text"
              target="_blank"
              >生活服务</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-s-custom"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/jiankangliren/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":22,"index":"9_1","title":"丽人"}}'
              class="link nav-text"
              target="_blank"
              >丽人</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiankangliren/c74/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":74,"index":"9_2","title":"美发"}}'
              class="link nav-text"
              target="_blank"
              >美发</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiankangliren/c20423/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20423,"index":"9_3","title":"医学美容"}}'
              class="link nav-text"
              target="_blank"
              >医学美容</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-present"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/jiehun/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20178,"index":"10_1","title":"结婚"}}'
              class="link nav-text"
              target="_blank"
              >结婚</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiehun/c20198/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20198,"index":"10_2","title":"婚纱摄影"}}'
              class="link nav-text"
              target="_blank"
              >婚纱摄影</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiehun/c20210/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20210,"index":"10_3","title":"婚宴"}}'
              class="link nav-text"
              target="_blank"
              >婚宴</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-sunny"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/qinzi/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":67,"index":"11_1","title":"亲子"}}'
              class="link nav-text"
              target="_blank"
              >亲子</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/qinzi/c20108/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20108,"index":"11_2","title":"儿童乐园"}}'
              class="link nav-text"
              target="_blank"
              >儿童乐园</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/qinzi/c20045/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20045,"index":"11_3","title":"幼教"}}'
              class="link nav-text"
              target="_blank"
              >幼教</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-bicycle"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/yundongjianshen/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":39,"index":"12_1","title":"运动健身"}}'
              class="link nav-text"
              target="_blank"
              >运动健身</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/yundongjianshen/c20253/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20253,"index":"12_2","title":"健身中心"}}'
              class="link nav-text"
              target="_blank"
              >健身中心</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-truck"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/jiazhuang/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20179,"index":"13_1","title":"家装"}}'
              class="link nav-text"
              target="_blank"
              >家装</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiazhuang/c20182/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20182,"index":"13_2","title":"建材"}}'
              class="link nav-text"
              target="_blank"
              >建材</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/jiazhuang/c20771/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20771,"index":"13_3","title":"家居"}}'
              class="link nav-text"
              target="_blank"
              >家居</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-watch-1"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/jiaoyupeixun/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20285,"index":"14_1","title":"学习培训"}}'
              class="link nav-text"
              target="_blank"
              >学习培训</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/xuexipeixun/c20287/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20287,"index":"14_2","title":"音乐培训"}}'
              class="link nav-text"
              target="_blank"
              >音乐培训</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-first-aid-kit"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/yiliao/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20274,"index":"15_1","title":"医疗健康"}}'
              class="link nav-text"
              target="_blank"
              >医疗健康</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/chongwu/c20691/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":20691,"index":"15_2","title":"宠物"}}'
              class="link nav-text"
              target="_blank"
              >宠物</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/aiche/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":27,"index":"15_3","title":"爱车"}}'
              class="link nav-text"
              target="_blank"
              >爱车</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
      <dd class="nav-li">
        <i class="el-icon-goblet-full"></i
        ><span class="nav-text-wrapper"
          ><span
            ><a
              href="https://bj.meituan.com/xiuxianyule/c234/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":234,"index":"16_1","title":"酒吧"}}'
              class="link nav-text"
              target="_blank"
              >酒吧</a
            >
            / </span
          ><span
            ><a
              href="https://bj.meituan.com/xiuxianyule/c230/"
              data-bid="b_atx2p7dc"
              data-lab='{"custom":{"cat_id":230,"index":"16_2","title":"密室逃脱"}}'
              class="link nav-text"
              target="_blank"
              >密室逃脱</a
            ></span
          ></span
        >
        <span class="arrow"></span>
      </dd>
    </dl>
    <div
      v-if="curDetail"
      class="detail"
      @mouseenter="detailEnter"
      @mouseleave="detailLeave"
    >
      <template v-for="(item, index) in curDetail.items">
        <h4 :key="index">{{ item.title }}</h4>
        <a href="javascript:;" class="link detail-more" target="_blank"
          >更多<i class="el-icon-arrow-right"></i
        ></a>
        <span v-for="(v, i) in item.items" :key="v + '_' + i">{{ v }}</span>
      </template>
    </div>
  </div>
</template>
<script>
import api from "@/api/index.js";
export default {
  data() {
    return {
      menuList: [], //左侧导航一级菜单列表
      curDetail: null, //二级菜单
    };
  },
  created() {
    api.getMenuList().then((res) => {
      this.menuList = res.data.data;
    });
  },
  methods: {
    menuEnter(item) {
      // console.log(item);
      this.curDetail = item;
    },
    menuLeave() {
      var self = this;
      this.timer = setTimeout(function() {
        self.curDetail = null;
      }, 200);
    },
    detailEnter() {
      clearTimeout(this.timer);
    },
    detailLeave() {
      this.curDetail = null;
    },
  },
};
</script>
